import { CreateAutomatedSegmentUploadScreen } from "types";
import { createScreen } from "utils/createScreen";

const CreateAutomatedProgrammaticSegmentDefinition = createScreen({
  name: CreateAutomatedSegmentUploadScreen,
  path: "/media-activation/programmatic-segments/automated/create",
  routePath: ["/automated/create"],
  accessPath: "programmaticCampaign.programmaticDomain",
});

export { CreateAutomatedProgrammaticSegmentDefinition };
